import { PtypString8 } from "msg-parser";
import Seat from "./Seat";
import { SpaceProps } from "./types";

export default function Space({
  type,
  person,
  position,
  isActive,
  activePerson,
  border = [],
  onHighlightFunders,
  orders,
  relationshipsMap,
  label,
  styleOverrides = {},
  innerStyleOverrides = {}
}: SpaceProps) {
  const className = `seat ${type} ${border.join(" ")} ${isActive ? "active" : ""}`;
  const baseStyle = { gridRow: position.row, gridColumn: position.col };

  if (type === "seat") {
    return (
      <Seat
        person={person}
        activePerson={activePerson}
        position={position}
        border={border}
        isActive={isActive}
        onHighlightFunders={onHighlightFunders}
        orders={orders}
        relationshipsMap={relationshipsMap}
      />
    );
  }

  const renderStaticBlock = (label?: string, styleOverrides = {}, stylesInnerOverride = {}) => (
    <div className={className} style={{ ...baseStyle, ...styleOverrides }}>
      {label && (
        <div className="innerSeat" style={{ ...stylesInnerOverride }}>
          {label}
        </div>
      )}
    </div>
  );

  switch (type) {
    case "printer":
      return renderStaticBlock(
        "Printer",
        { cursor: "default" },
        {
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          fontSize: 14
        }
      );
    case "custom":
      return renderStaticBlock(
        label,
        {
          // backgroundColor: "rgba(200, 200, 255, 0.3)", // or none
          cursor: "default",
          padding: " 8px"
        },
        {
          backgroundColor: "rgba(200, 200, 255, 0.3)", // or none
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          fontSize: 14,
          borderRadius: "8px"
        }
      );

    case "door":
      return renderStaticBlock("Door", {
        backgroundColor: "rgba(242, 242, 242, 0.7)",
        cursor: "default"
      });

    case "hallway":
      return renderStaticBlock(undefined, {
        backgroundColor: "rgba(242, 242, 242, 0.5)",
        cursor: "default"
      });

    case "empty":
      return renderStaticBlock(
        "Empty",
        {
          cursor: "default",
          color: "rgba(0, 0, 0, 0.3)"
        },
        {
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          textAlign: "center"
        }
      );

    default:
      return <div className={className} style={baseStyle} />;
  }
}
